// src/components/PersistentPlayerPortal.js
import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import PersistentPlayer from "./PersistentPlayer"

const PersistentPlayerPortal = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    const el = document.getElementById("persistent-player-root")
    if (el) setMounted(true)
  }, [])

  if (!mounted) return null
  return createPortal(
    <PersistentPlayer />,
    document.getElementById("persistent-player-root")
  )
}

export default PersistentPlayerPortal
